import { render, staticRenderFns } from "./situacoes-evento-list.vue?vue&type=template&id=364afc18"
import script from "./situacoes-evento-list.vue?vue&type=script&lang=js"
export * from "./situacoes-evento-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports